import { render, staticRenderFns } from "./AdminPerformanceStatsTable.vue?vue&type=template&id=d34d14c0&scoped=true&"
import script from "./AdminPerformanceStatsTable.vue?vue&type=script&lang=js&"
export * from "./AdminPerformanceStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminPerformanceStatsTable.vue?vue&type=style&index=0&id=d34d14c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34d14c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d34d14c0')) {
      api.createRecord('d34d14c0', component.options)
    } else {
      api.reload('d34d14c0', component.options)
    }
    module.hot.accept("./AdminPerformanceStatsTable.vue?vue&type=template&id=d34d14c0&scoped=true&", function () {
      api.rerender('d34d14c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminPerformanceStatsTable.vue"
export default component.exports